<template>
  <v-container class="mb-5 pa-5 bg" v-editable="blok">
    <v-row>
      <v-container class="px-5">
        <v-row justify="center" v-if="story">
          <v-col cols="12">
            <div class="title mb-5">
              <h2>{{blok.title}}</h2>
              <div class="pb-icon">
                <figure>
                  <img src="@/assets/logo_mini_dark.svg" alt />
                </figure>
                <div class="after">
                </div>
              </div>
            </div>
          </v-col>
          
          <v-col cols="12" sm="6" md="6" class="d-flex" v-for="(item, index) in story" :key="index" >
            <v-card class="text-left card pa-5" tile dark :to="`/${item.full_slug}`">
              <em>{{item.content.category}}</em>
              <h4>{{item.content.title}}</h4>
              <em>{{item.content.date}}</em>
              <p>{{item.content.shortDescription}}</p>
            </v-card>  
          </v-col>
        </v-row>
       
      </v-container>
    </v-row>
  </v-container>
</template>


<style lang="scss" scoped>
@import "./Featured.scss";
</style>

<script>
// 1. Require the Storyblok client
import StoryblokClient from 'storyblok-js-client'

// 2. Set your token
const token = 'vNbkVTgCgnArqEk6TG7LQwtt';

// 3. Initialize the client with the preview token so we can access our API easily
// from your space dashboard at https://app.storyblok.com
let storyapi = new StoryblokClient({
  accessToken: token
});
export default {
  data() {
    return {
      story: null
    };
  },
 mounted () {
    // 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token
    })
    window.storyblok.on('change', () => {
      this.getBlogs(`${this.blok.lenguage}/blog-articles`, 'draft')
    })
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getBlogs(`${this.blok.lenguage}/blog-articles`, 'draft')
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getBlogs(`${this.blok.lenguage}/blog-articles`, 'published')
      }
    })
  },
  methods: {
    getBlogs(slug, version) {
      storyapi.get('cdn/stories/', {
        version: version,
        by_uuids: this.blok.blogs,
        sort_by: "created_at:asc",
        page: 1,
        per_page:2
      })
      .then((response) => {
        this.story = response.data.stories;
      })
      .catch((error) => {
        console.log(error);
      })
    }
  },
  props: ["blok"]
};
</script>
